/* This class is generic across multiple player technologies.
 * Do NOT put any player-specific code in this class.
 */

class Simplestream {

    constructor(id) {

        this.id = id;
        this.version = '1.0.0-2024-08-10';
        this.embedCode = document.getElementById(this.id);

        var $_GET=[];
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(a,name,value){$_GET[name]=value;});
        this.getParams = Object.assign({}, $_GET);

        this.log('Simplestream Media Player');

        this.checkAttributes();

    }

    checkAttributes() {

        this.log('Simplestream::checkAttributes()');

        this.data = this.embedCode.dataset;
        this.data.platform = this.detectPlatform();

        // Check for required data attributes
        if(this.data.key == '8Uq4Dk4Cm8Hn3Zj9Bj9Ga5Iz6Sh1Ib' && this.data.id != 'mediamanager') { // spafax
            var requiredDataAttributes = ['id', 'type', 'key', 'externalId', 'accessToken', 'subscriptionKey'];
        } else {
            var requiredDataAttributes = ['id', 'type', 'key', 'token', 'expiry', 'uvid'];
        }
        for (var i = 0; i < requiredDataAttributes.length; ++i) {
            if (!(requiredDataAttributes[i] in this.data)) {
                return this.errorScreen('Embed Code is missing the "' + requiredDataAttributes[i] + '" attribute.');
            }
        }

        // Validate optional env attribute
        if(!['production', 'staging'].includes(this.data.env)) {
            this.data.env = 'production';
        }

        // Validate type
        if(this.data.type == 'vod') {
            this.data.type = 'show';
        }

        // Validate userid
        if(!this.data.userid) {
            this.data.userid = null;
        }

        // Validate countryCode
        if(!this.data.country) {
            this.data.country = null;
        }

        if(this.data.config) {
            this.config = JSON.parse(this.data.config);
        }

        this.log(JSON.stringify(this.data, undefined, 2));

        this.detectAdblock();
        
    }

    detectAdblock() {

        this.log('Simplestream::detectAdblock()');

        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'https://mm-dev.simplestream.com/froloa.js', true);
        xhr.onload = () => {
            if (xhr.status === 200) {
                this.getPlayer();
            }
        };
        xhr.onerror = () => {
            this.errorScreen('Please disable your ad blocker to watch this content.');
        };
        xhr.send();

    }

    detectPlatform() {

        this.log('Simplestream::detectPlatform()');
        
        var ua = window.navigator.userAgent;
            
        // Opera 8.0+
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        
        // Firefox 1.0+
        var isFirefox = typeof InstallTrigger !== 'undefined';
        
        // Safari 3.0+ "[object HTMLElementConstructor]" 
        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
            
        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        
        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;
        
        // Chrome 1 - 79
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        
        // Edge (based on chromium) detection
        var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
        
        // Safari iOS
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
        
        // Chrome iOS
        var iOSChrome = !!ua.match(/CriOS/i);
        var isAndroidChrome = ua.match(/Chrome\/[.0-9]*/i);
        
        var platform = false;
        if(isSafari || iOSSafari) {
            var platform = 'safari';
        } else if(isFirefox) {
            var platform = 'firefox';
        } else if(iOSChrome) {
            var platform = 'safari';
        } else if(isChrome || isEdgeChromium || isAndroidChrome) {
            var platform = 'chrome';
        } else if(isEdge) {
            var platform = 'edge';
        } else {
            
            var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                navigator.userAgent &&
                navigator.userAgent.indexOf('CriOS') == -1 &&
                navigator.userAgent.indexOf('FxiOS') == -1;
            
            if(isSafari) {
                var platform = 'safari';
            } else {
                var platform = 'unknown';	
            }
            
        }

        this.log('Platform: ' + platform);
    
        return platform;
    
    }

    getPlayer() {

        this.log('Simplestream::getPlayer()');

        var url = 'https://mm-v2.simplestream.com/ssmp/api.php?id=' + this.data.id + '&env=' + this.data.env;

        this.log('Player API: ' + url);

        fetch(url, {
            method: 'get',
        }).then((response) => {
            return response.json();
        }).then((json) => {
            this.playerApiResponse = json.response;
            this.log('Player API Response:\n' + JSON.stringify(this.playerApiResponse, undefined, 2));
            this.validatePlayer();
        }).catch((error) => {
            return this.errorScreen('Failed To Fetch Player Config');
        });

    }

    validatePlayer() {

        this.log('Simplestream::validatePlayer()');

        // Spafax
        if(this.playerApiResponse.company_id == 202 && !this.data.skipValidation) {

            if(this.data.env == 'staging') {
                var url = 'https://stage-profile-core-main-api.azure-api.net/stream/v2/auth/validate-token';
            } else {
                var url = 'https://prod-profile-core-main-api.azure-api.net/stream/v2/auth/validate-token';
            }

            fetch(url, {
                method: 'post',
                headers: {
                    'Authorization': 'Bearer ' + this.data.accessToken,
                    'Ocp-Apim-Subscription-Key': this.data.subscriptionKey,
                }
            }).then((response) => {
                return response.json();
            }).then((json) => {
                if(json.statusCode != 200) {
                    return this.errorScreen('Invalid Subscription Key');
                }
                this.getConsent();
            }).catch((error) => {
                return this.errorScreen('Failed To Connect To Validation API');
            });

        } else {
            this.getConsent();
        }

    }

    getConsent() {

        this.log('Simplestream::getConsent()');

        if (typeof __tcfapi !== 'undefined') {
            //console.log('__tcfapi is defined.');
            if (typeof window._sp_.version !== 'undefined') {
                //console.log('window._sp_.version is defined.');
                __tcfapi('getTCData', 2, (tcData, success) => {
                    if(success) {
                        this.getStream(1, tcData.tcString);
                    } else {
                        //console.log('getTCData failed');
                    }
                });
            } else {
                //console.log('window._sp_.version not defined.');
                this.getStream(1, null);
            }
        } else {
            //console.log('__tcfapi is not defined.');
            this.getStream(1, null);
        }

    }

    getStream(gdpr, gdpr_consent) {

        this.log('Simplestream::getStream()');

        if(this.data.externalId) {
            this.data.uvid = '00000000';
        }

        if(this.playerApiResponse.api_hostname.includes('https://api')) {
            this.streamsApiRequest = this.playerApiResponse.api_hostname + '/streams/v2/' + this.playerApiResponse.company_uuid + '/' + ((this.data.type == 'live') ? 'live' : 'vod') + '/' + this.data.uvid;
        } else {
            this.streamsApiRequest = this.playerApiResponse.api_hostname + '/streams/api/' + this.data.type + '/stream/' + this.data.uvid;
        }
        
        this.streamsApiRequest +=
            '?key=' + this.data.key +
            '&cc=' + this.data.country +
            '&platform=' + this.data.platform +
            //'&autoplay=' + (this.playerApiResponse.settings_autoplay ? 'autoplay' : 'click') +
            //'&muted=' + (this.playerApiResponse.settings_automute ? '1' : '0') +
            '&url=' + encodeURIComponent(window.location.href) +
            '&gdpr=' + gdpr +
            '&gdpr_consent=' + gdpr_consent;

        if(this.data.uvid == '00000000') {
            this.streamsApiRequest += '&external_id=' + this.data.externalId;
        }

        this.log('Streams API: ' + this.streamsApiRequest);

        fetch(this.streamsApiRequest, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Token': this.data.token,
                'Token-Expiry': this.data.expiry,
                'Userid': '123456',
                'Uvid': this.data.uvid,
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            this.streamsApiResponse = json.response;
            this.log('Streams API Response:\n' + JSON.stringify(this.streamsApiResponse, undefined, 2));
            if(this.streamsApiResponse.error) {
                return this.errorScreen('Streams API / ' + this.streamsApiResponse.error);
            } else {

                //let debug = document.createElement('div');
                //debug.innerHTML = '<pre>' + JSON.stringify(this.streamsApiResponse, undefined, 2) + '</pre>';
                //this.embedCode.appendChild(debug);

                this.streamsApiResponse = this.streamsApiAdaptor(json.response);
                this.log('Streams API Adaptor:\n' + JSON.stringify(this.streamsApiResponse, undefined, 2));
                
                this.getAnalytics();

            }
        }).catch((error) => {
            return this.errorScreen('Failed To Connect To Streams API');
        });

    }

    streamsApiAdaptor(streamsApiResponse) {

        this.log('Simplestream::streamsApiAdaptor()');

        // Disable CSAI and SSAI if data-config is set
        if(this.config?.csai == 'disabled') {
            streamsApiResponse.ads.csai = null;
        }
        if(this.config?.ssai == 'disabled') {
            streamsApiResponse.ads.ssai = null;
        }

        // If "ads" contains "csai", "ssai" and/or "pause", then it's already in the new format
        if(streamsApiResponse.ads?.csai || streamsApiResponse.ads?.ssai || streamsApiResponse.ads?.pause) {
            return streamsApiResponse;
        }

        // If "ident", convert to preroll
        if(streamsApiResponse.ident) {
            streamsApiResponse.ads = {};
            streamsApiResponse.ads.csai = {};
            streamsApiResponse.ads.csai.preroll = {};
            streamsApiResponse.ads.csai.preroll.provider = 'google';
            streamsApiResponse.ads.csai.preroll.vast = 'https://v2-streams-staging-elb.simplestreamcdn.com/vastIdent.php?mp4=' + streamsApiResponse.ident;
            delete streamsApiResponse.ident;
            this.log('Streams API Adaptor:\n' + JSON.stringify(streamsApiResponse, undefined, 2));
            return streamsApiResponse;
        }

        const oldAds = streamsApiResponse.ads;
        streamsApiResponse.ads = null;

        // AWS Media Tailor
        if(oldAds?.type == 'ssai' 
            && oldAds?.provider == 'media-tailor') {

            delete oldAds.type;

            streamsApiResponse.ads = {};
            streamsApiResponse.ads.ssai = oldAds;

        // AWS Media Tailor
        } else if(oldAds?.type == 'ssai' 
            && oldAds?.provider == 'google-video-stitcher') {

            streamsApiResponse.ads = {};

            if(oldAds.prerollAdTag) {
                streamsApiResponse.ads.csai = {};
                streamsApiResponse.ads.csai.preroll = {};
                streamsApiResponse.ads.csai.preroll.provider = 'google';
                streamsApiResponse.ads.csai.preroll.vast = oldAds.prerollAdTag;
            }

            delete oldAds.type;
            delete oldAds.prerollAdTag;

            streamsApiResponse.ads.ssai = oldAds;

        // Google IMA
        } else if(oldAds?.provider == 'google') {

            streamsApiResponse.ads = {};
            streamsApiResponse.ads.client = oldAds;

        // Google IMA with 3rd-party preroll and/or midroll VAST tags
        } else if(oldAds?.preroll_vast) {

            streamsApiResponse.ads = {};
            streamsApiResponse.ads.client = oldAds;

        }

        return streamsApiResponse;

    }

    /* 
     * Call the Analytics API.
     */
    getAnalytics() {

        this.log('Simplestream::getAnalytics()');

        if(this.playerApiResponse.api_hostname.includes('https://api')) {
            var url = this.playerApiResponse.api_hostname + '/analytics/v1/' + this.playerApiResponse.company_uuid + '/analytics';
        } else {
            var url = 'https://api' + ((this.data.env == 'staging') ? '-staging' : '') + '.simplestreamcdn.com/analytics/v1/' + this.playerApiResponse.company_uuid + '/analytics';
        }

        if(this.streamsApiResponse.drm
            && this.streamsApiResponse.drm.widevine) {
            var contentResource = this.streamsApiResponse.drm.widevine.stream;
        } else if(this.streamsApiResponse.drm
            && this.streamsApiResponse.drm.fairplay) {
            var contentResource = this.streamsApiResponse.drm.fairplay.stream;
            } else {
            var contentResource = this.streamsApiResponse.stream;
        }

		var postBody = {
	    	"user": this.data.analytics?.userid ?? this.data.userid,
	    	"content_resource" : contentResource,
	    	'content_contracted_resolution' : this.embedCode.querySelector('.aspect-ratio-16x9-content').offsetWidth + 'x' + this.embedCode.querySelector('.aspect-ratio-16x9-content').offsetHeight,
            "cc" : this.data.country,
	    	"lang" : 'en',
	    	"region_code" : null,
	    	"stream_type" : this.data.type,
	    	'download' : '0',
	    	'device' : 'web',
	    	'app_name' : (typeof this.playerApiResponse.company_name !== 'undefined') ? this.playerApiResponse.company_name : null,
	    	'platform' : 'web',
	    	'app_release_version' : 'ssmp-' + this.version,
	    	'unique_video_id' : this.data.uvid,
	    };

        this.log('Analytics API: ' + url + '\n' + JSON.stringify(postBody, undefined, 2));

        fetch(url, {
            method: 'post',
            body: JSON.stringify(postBody),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-api-key': this.data.key,
            },
        }).then((response) => {
            return response.json();
        }).then((json) => {

            // BUGFIX: Needs to be fixed on Analytics API
            delete json.username;
            json['user.name'] = null;

            if (typeof this.data.analytics !== "undefined") {
                let analytics = JSON.parse(this.data.analytics);
                if (typeof analytics.usertype !== "undefined") {
                    json['content.customDimension.5'] = analytics.usertype;
                }
                if (typeof analytics.userid !== "undefined") {
                    json['user.name'] = analytics.userid;
                }
            }

            this.analyticsApiResponse = json;
            this.log('Analytics API Response:\n' + JSON.stringify(this.analyticsApiResponse, undefined, 2));
            this.ready();

        }).catch((error) => {
            return this.errorScreen('Failed To Connect To Analytics API');
        });   

    }

    /* 
     * Dispatches the 'simplestream-ready' event when all API calls have completed.
     */
    ready() {

        this.log('Simplestream::ready()');

        document.dispatchEvent(new CustomEvent('simplestream-ready', {
            detail: {
                attributes: Object.assign({}, this.data),
                analyticsApiResponse: this.analyticsApiResponse,
                playerApiResponse: this.playerApiResponse,
                streamsApiRequest: this.streamsApiRequest,
                streamsApiResponse: this.streamsApiResponse,
            }
        }));

    }

    /* 
     * Outputs a log message to the console.
     */
    log(msg) {
        console.log(this.embedCode.id + ' - ' + msg);
    }

    /* 
     * Renders the error screen.
     */
    errorScreen(msg) {

        this.log('Simplestream::errorScreen()');

        const error = document.createElement('div');
        error.setAttribute('class', 'error');
        this.embedCode.querySelector('.aspect-ratio-16x9-content').innerHTML = '';
        this.embedCode.querySelector('.aspect-ratio-16x9-content').appendChild(error);

        const img = document.createElement('img');
        img.src = 'data:image/png;base64,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';
        error.appendChild(img);

        const p = document.createElement('p');
        p.textContent = msg;
        error.appendChild(p);

    }
}

export default Simplestream;